module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select-org', {
    attrs: {
      "label": _vm.label,
      "type": "Telco",
      "required": _vm.required,
      "placeholder": _vm.placeholder,
      "help-text": _vm.helpText,
      "size": _vm.size,
      "disabled": _vm.disabled,
      "full-object": _vm.fullObject,
      "no-form": _vm.noForm,
      "limit": _vm.localLimits
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eff10e46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectSharer.vue
// module id = 1737
// module chunks = 0